import { render, staticRenderFns } from "./UserAvatarDialog.vue?vue&type=template&id=48869e34&scoped=true&"
import script from "./UserAvatarDialog.vue?vue&type=script&lang=js&"
export * from "./UserAvatarDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserAvatarDialog.vue?vue&type=style&index=0&id=48869e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48869e34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VDialog,VFileInput,VIcon,VSheet})
